module.exports = __webpack_public_path__ + "static/img/LI.2ec7f821.svg";